<template>
  <PaginationWrapper
    v-slot="{
      pageSize,
      setPageSize,
      setCurrentPage,
      total,
      currentPage,
      currentPageData,
    }"
    :data="data"
  >
    <WithManualPagination
      :show-pagination="total > pageSize && !isLoading"
      :page-size="pageSize"
      :current-page="currentPage"
      :total="total"
      @size-change="setPageSize"
      @current-change="setCurrentPage"
    >
      <div
        v-loading="isLoading"
        :class="['table-responsive', { raised: isRaised }]"
      >
        <slot :currentPageData="currentPageData" />
      </div>
    </WithManualPagination>
  </PaginationWrapper>
</template>

<script>
import pagination from '@/mixins/pagination';
import WithManualPagination from './WithManualPagination';
import PaginationWrapper from './PaginationWrapper';
export default {
  name: 'WithPagination',
  components: { WithManualPagination, PaginationWrapper },
  mixins: [pagination],

  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Array,
      default: () => [],
    },
    isRaised: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss">
.with-pagination {
  &__pagination {
    margin-top: $global-margin * 2;
  }
}
</style>
